import { post,get } from "../network/index.js";
  //查询详情
  const queryActivityDetail = (data) => {
      return post("/mercWebi/busMercActivity/queryDetail",data);
  }
  //列表营销活动
  const queryActivityList = (data) => {
      return post("/mercWebi/busMercActivity/queryList", data);
    };
    //编辑营销活动
  const updateActivity = (data) => {
    return post("/mercWebi/busMercActivity/update", data);
  };

  // 修改营销活动状态
  const updateStatus = (data) => {
    return post("/mercWebi/busMercActivity/updateStatus", data);
  };
  // 修改优惠券状态
  const updateCouponStatus = (data) => {
    return post("/mercWebi/couponInfo/updateStatus", data);
  };

  // 新增营销活动
  const addMercActivity = (data) => {
    return post("/mercWebi/busMercActivity/add", data);
  };
  // 参与活动用户统计列表
  const participantList = (data) => {
      return post("/mercWebi/busMercActivity/participantList", data);
  };
  // 参与活动用户统计列表
  const participantStatistic = (data) => {
      return post("/mercWebi/busMercActivity/participantStatistic", data);
  };
  // 被邀请人列表
  const inviteeList = (data) => {
      return post("/mercWebi/busMercActivity/inviteeList", data);
  };

export default {
    queryActivityList,
    updateActivity,
    queryActivityDetail,
    updateStatus,
    updateCouponStatus,
    addMercActivity,
    participantList,
    participantStatistic,
    inviteeList,
};
